module.exports = __webpack_public_path__ + "img/banner-chatbotnow.bd3b6373.png";